import DeviceVerificationStatus from './DeviceVerificationStatus';

export default DeviceVerificationStatus;
